/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_VerifyingInputs */

const he_verify_verifying = /** @type {(inputs: Verify_VerifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מאמת...`)
};

const en_verify_verifying = /** @type {(inputs: Verify_VerifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifying...`)
};

/**
* | output |
* | --- |
* | "Verifying..." |
*
* @param {Verify_VerifyingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const verify_verifying = /** @type {((inputs?: Verify_VerifyingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_VerifyingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_verify_verifying(inputs)
	return en_verify_verifying(inputs)
});